module.exports = __webpack_public_path__ + "cf29164929282069d596e9b6d9036c60.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/components/info-sharing-accounts/info-sharing-accounts.html
// module id = 936
// module chunks = 0